import React, { useState } from 'react';
import { useAuth } from './AuthContext';

const BACKEND_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminCreateUser = ({ onUserCreated }) => {
  const { token } = useAuth();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    role: 'USER',
    company: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    if (!formData.firstName || !formData.lastName || !formData.email || !formData.password) {
      setMessage({ type: 'error', text: 'Please fill in all required fields.' });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/admin/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to create user');
      }

      setMessage({ type: 'success', text: `User ${data.user.email} created successfully!` });
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: 'USER',
        company: '',
      });

      if (onUserCreated) {
        onUserCreated(data.user);
      }
    } catch (err) {
      setMessage({ type: 'error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-admin" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h1 className="title-blue">Create New User</h1>
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Add a new Individual, Business, or Admin user directly to the platform.
      </p>

      {message.text && (
        <div
          style={{
            padding: '12px 16px',
            borderRadius: '6px',
            marginBottom: '20px',
            backgroundColor: message.type === 'error' ? '#fde8e8' : '#e6fffa',
            color: message.type === 'error' ? '#e53e3e' : '#234e52',
            border: `1px solid ${message.type === 'error' ? '#feb2b2' : '#b2f5ea'}`,
          }}
        >
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
          <div>
            <label className="label-admin">First Name *</label>
            <input
              type="text"
              name="firstName"
              className="input"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="e.g. John"
              required
            />
          </div>
          <div>
            <label className="label-admin">Last Name *</label>
            <input
              type="text"
              name="lastName"
              className="input"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="e.g. Doe"
              required
            />
          </div>
        </div>

        <div style={{ marginTop: '15px' }}>
          <label className="label-admin">Email Address *</label>
          <input
            type="email"
            name="email"
            className="input"
            value={formData.email}
            onChange={handleChange}
            placeholder="e.g. john@example.com"
            required
          />
        </div>

        <div style={{ marginTop: '15px' }}>
          <label className="label-admin">Password *</label>
          <input
            type="password"
            name="password"
            className="input"
            value={formData.password}
            onChange={handleChange}
            placeholder="Minimum 6 characters"
            required
          />
        </div>

        <div style={{ marginTop: '15px' }}>
          <label className="label-admin">Account Role</label>
          <select name="role" className="select" value={formData.role} onChange={handleChange}>
            <option value="USER">Individual User (USER)</option>
            <option value="BUSINESS">Corporate Account (BUSINESS)</option>
            <option value="ADMIN">Super Admin (ADMIN)</option>
          </select>
        </div>

        {formData.role === 'BUSINESS' && (
          <div style={{ marginTop: '15px' }}>
            <label className="label-admin">Company / Organization Name</label>
            <input
              type="text"
              name="company"
              className="input"
              value={formData.company}
              onChange={handleChange}
              placeholder="e.g. Acme Safety Corp"
            />
          </div>
        )}

        <button
          type="submit"
          className="button"
          disabled={loading}
          style={{ marginTop: '25px', width: '100%' }}
        >
          {loading ? 'Creating User...' : 'Create User Account'}
        </button>
      </form>
    </div>
  );
};

export default AdminCreateUser;
